import React,{useState,createContext, useEffect} from 'react';
import axios from 'axios';

export const AboutPageContext = createContext();

const AboutPageContextProvider = (props) =>{
    const [aboutpagedata,setAboutPageData]=useState();

    useEffect(()=>{
        getAboutPageData();
    },[])

    const getAboutPageData = async () =>{
        await axios({
            method:'get',
            url:`${process.env.REACT_APP_API_BASE_URL}/about`,
            headers: {
              'Authorization': `${process.env.REACT_APP_HEADER_TOKEN}`
            }
          })
          .then((response)=>{
            setAboutPageData(response.data)
          })
          .catch((err)=>{
            console.log(err)
          })
    }

    return(
        <AboutPageContext.Provider value={{aboutpagedata,setAboutPageData}}>
            {props.children}
        </AboutPageContext.Provider>
    )
}

export default AboutPageContextProvider;